import { Skeleton } from '@heroui/react';
import { BlobsBackground } from '@milestone-portal/ui/BlobsBackground/BlobsBackground';
import { DesktopContainer } from '@milestone-portal/ui/DesktopContainer/DesktopContainer';
import { Footer } from '@milestone-portal/ui/Footer/Footer';
import { HeaderBar } from '@milestone-portal/ui/HeaderBar/HeaderBar';

export function PrivateProfileSkeleton() {
  return (
    <div className="flex w-full flex-col">
      <DesktopContainer>
        <HeaderBar />
        <BlobsBackground />
        <div className="flex flex-col gap-4 p-8">
          {/* PrivateProfileHeader Skeleton */}
          <div className="overflow-hidden rounded-xl shadow-lg">
            {/* ProfileBackground */}
            <div className="relative px-4 py-6">
              <div className="flex flex-col items-center md:flex-row md:items-start md:gap-6">
                {/* Avatar */}
                <div className="size-[96px]">
                  <Skeleton className="relative z-10 size-[96px] rounded-full p-[2px]" />
                </div>

                {/* User Info */}
                <div className="mt-4 flex max-w-screen-lg flex-col items-center gap-2 md:mt-0 md:flex-1 md:items-start">
                  <Skeleton className="h-8 w-48 rounded-lg" />
                  <Skeleton className="h-6 w-36 rounded-lg" />
                  <Skeleton className="h-4 w-[400px] rounded-md" />
                  <Skeleton className="h-4 w-[300px] rounded-md" />
                </div>

                {/* Action Buttons */}
                <div className="mt-4 flex gap-2 md:ml-auto md:flex-col md:self-start">
                  <Skeleton className="h-8 w-24 rounded-lg" />
                  <Skeleton className="h-8 w-24 rounded-lg" />
                  <Skeleton className="h-8 w-24 rounded-lg" />
                </div>
              </div>
            </div>
          </div>

          {/* Query & Action Bars */}
          <div className="mt-4 flex flex-row flex-wrap gap-4">
            {/* QueryOperationBar */}
            <div className="flex min-w-[300px] flex-1 gap-2">
              <Skeleton className="h-10 w-[200px] rounded-lg" />
              <Skeleton className="h-10 w-20 rounded-lg" />
            </div>

            {/* ListActionBar */}
            <div className="flex gap-2">
              <Skeleton className="h-10 w-32 rounded-lg" />
              <Skeleton className="h-10 w-24 rounded-lg" />
            </div>
          </div>

          {/* Tabs Skeleton */}
          <Skeleton className="mt-2 h-10 w-full rounded-lg" />

          {/* Achievement Grid - Based on AchievementCard structure */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5">
            {Array.from(Array(10).keys()).map((i) => (
              <div
                className="relative w-full overflow-hidden rounded-lg p-1 shadow-md"
                key={i}
              >
                {/* Border effect */}
                <Skeleton className="absolute inset-0 rounded-md opacity-20" />

                {/* Card Body */}
                <div className="relative z-10 flex h-full flex-col items-center p-3">
                  {/* Medal icon */}
                  <Skeleton className="mb-2 size-8 rounded-full" />

                  {/* Title */}
                  <Skeleton className="mb-4 h-6 w-4/5 rounded-md" />

                  {/* Image container */}
                  <div className="flex flex-col items-center gap-2">
                    <Skeleton className="aspect-square size-32 rounded-md" />

                    {/* Date */}
                    <div className="flex items-center gap-2">
                      <Skeleton className="size-4 rounded-full" />
                      <Skeleton className="h-4 w-24 rounded-md" />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <Footer />
      </DesktopContainer>
    </div>
  );
}
